import { useSelector } from "react-redux";

export const useUser = () => {
  try {
    let { user } = useSelector(({ authentication }) => authentication);

    if(!user){
      let data = sessionStorage.getItem("sn-gestion-legal");

      if (data) {
        data = JSON.parse(user);
  
        return data;
      }
      else {
        return null;
      }
    }

    return user;
  } catch (e) {
    console.error(e);
  }
};
